module.exports = __webpack_public_path__ + "c038aab3cd10f65a7221991f9e533318.fbx";